import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import Button from '../Button';

const ConnectAsClientBannerContainer = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  background-color: rgba(211, 86, 54, 0.4);
  padding-left: 30px;
  opacity: 0.8;
  pointer-events: none;
  margin-right: -40px;
  margin-left: -40px;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 998;

  p {
    font-size: 14px;
    margin-left: 10px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  span {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    font-size: 16px;
  }

  .bannerButton {
    margin-left: 20px;
    pointer-events: auto;
  }
`;

const ConnectAsClientBanner = ({ name, onLogout }) => {
  const handleLogout = () => {
    localStorage.setItem('distribution_filters', '{}');
    localStorage.setItem('global_view_filters', '{}');
    onLogout();
  };
  return (
    <ConnectAsClientBannerContainer>
      <Icon icon="alert" />
      <p>
        Vous êtes connecté en tant que <span>{name}</span>
      </p>
      <div className="bannerButton">
        <Button
          label="Se déconnecter"
          onClick={handleLogout}
          textTransform="normal"
          height="30px"
          width="200px"
        />
      </div>
    </ConnectAsClientBannerContainer>
  );
};

export default ConnectAsClientBanner;
